// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a3c1d153","732":"4c9ecac9","977":"e2c9c3a9"}[chunkId] + ".chunk.js";
};